var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 105,
    viewBox: "0 0 103 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6358 13.9875C62.7493 9.75649 57.321 7.42651 51.3295 7.42651C45.3061 7.42651 39.8598 9.74239 35.9913 13.9472C32.0809 18.1984 30.1756 23.976 30.6229 30.2148C31.5097 42.5231 40.7985 52.5358 51.3295 52.5358C61.8606 52.5358 71.1334 42.5251 72.0341 30.2188C72.4875 24.0364 70.5702 18.2709 66.6358 13.9875Z",
    fill: "#1F256C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4814 97.6429H16.1813C15.2611 97.655 14.3498 97.46 13.5138 97.0723C12.6777 96.6846 11.9379 96.1138 11.3481 95.4015C10.05 93.8368 9.5267 91.7001 9.91415 89.5393C11.5998 80.1107 16.8603 72.1904 25.1285 66.6303C32.4741 61.6944 41.7789 58.9778 51.3313 58.9778C60.8838 58.9778 70.1885 61.6964 77.5341 66.6303C85.8024 72.1884 91.0629 80.1087 92.7485 89.5373C93.1359 91.6981 92.6127 93.8348 91.3145 95.3995C90.725 96.1122 89.9852 96.6833 89.1492 97.0714C88.3131 97.4595 87.4017 97.6547 86.4814 97.6429Z",
    fill: "#1F256C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.39961703.svg";
export { ForwardRef as ReactComponent };